import PasswordGenerator from "./Components/PasswordGenerator";
import "./App.css";

const App = () => <PasswordGenerator />;

export default App;
